module.exports = __webpack_public_path__ + "beads@2x.jpg?79e1d4239e0ce2d1fab2eca3b579e290";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beads@2x.jpg
// module id = 164
// module chunks = 0